import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() message!: string;
  @Input() isSMS: boolean = false;

  constructor(private modalController: ModalController) {}

  dismiss(event?: boolean) {
    this.modalController.dismiss(event);
  }
}
